import React from 'react';
import AuditActivityCard from './AuditActivityCard';
import type { AuditActivity } from '../../../../../types/auditLogs';

interface AuditActivitiesListProps {
  activities: AuditActivity[];
  isLoading?: boolean;
}

const AuditActivitiesList: React.FC<AuditActivitiesListProps> = ({ 
  activities, 
  isLoading = false 
}) => {
  if (isLoading) {
    return (
      <div className="audit-activities-list">
        <div className="audit-activities-header">
          <div className="section-icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
              <rect x="4" y="3" width="12" height="14" rx="1" stroke="currentColor" strokeWidth="1" fill="none"/>
              <rect x="6" y="2" width="8" height="2" rx="1" fill="currentColor"/>
              <path d="M7 8l2 2L13 7" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
              <line x1="7" y1="12" x2="13" y2="12" stroke="currentColor" strokeWidth="1" strokeLinecap="round"/>
              <line x1="7" y1="14" x2="10" y2="14" stroke="currentColor" strokeWidth="1" strokeLinecap="round"/>
            </svg>
          </div>
          <h3 className="section-title">Recent Audit Activities</h3>
        </div>
        <div className="audit-activities-loading">
          <div className="loading-spinner"></div>
          <span>Loading audit activities...</span>
        </div>
      </div>
    );
  }

  if (activities.length === 0) {
    return (
      <div className="audit-activities-list">
        <div className="audit-activities-header">
          <div className="section-icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
              <rect x="4" y="3" width="12" height="14" rx="1" stroke="currentColor" strokeWidth="1" fill="none"/>
              <rect x="6" y="2" width="8" height="2" rx="1" fill="currentColor"/>
              <path d="M7 8l2 2L13 7" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
              <line x1="7" y1="12" x2="13" y2="12" stroke="currentColor" strokeWidth="1" strokeLinecap="round"/>
              <line x1="7" y1="14" x2="10" y2="14" stroke="currentColor" strokeWidth="1" strokeLinecap="round"/>
            </svg>
          </div>
          <h3 className="section-title">Recent Audit Activities</h3>
        </div>
        <div className="audit-activities-empty">
          <p>No audit activities found for the selected criteria.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="audit-activities-list">
      <div className="audit-activities-header">
        <div className="section-icon">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
            <rect x="4" y="3" width="12" height="14" rx="1" stroke="currentColor" strokeWidth="1" fill="none"/>
            <rect x="6" y="2" width="8" height="2" rx="1" fill="currentColor"/>
            <path d="M7 8l2 2L13 7" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
            <line x1="7" y1="12" x2="13" y2="12" stroke="currentColor" strokeWidth="1" strokeLinecap="round"/>
            <line x1="7" y1="14" x2="10" y2="14" stroke="currentColor" strokeWidth="1" strokeLinecap="round"/>
          </svg>
        </div>
        <h3 className="section-title">Recent Audit Activities</h3>
      </div>
      <div className="audit-activities-content">
        {activities.map((activity) => (
          <AuditActivityCard key={activity.id} activity={activity} />
        ))}
      </div>
    </div>
  );
};

export default AuditActivitiesList;